import { activateButtonLoading } from './btn-loading';

document.addEventListener('DOMContentLoaded', function () {
  const loadables = document.querySelectorAll('.loadable');
  const app = document.querySelector('.app');

  const shouldScrollOnLoad = (loadable, sourceEl) => {
    if (loadable.hasAttribute('data-loadable-no-scroll')) return false;
    if (sourceEl?.hasAttribute('data-loadable-no-scroll')) return false;
    return true;
  };

  const getSubmitControl = (form, submitEvent) => {
    const submitter = submitEvent?.submitter;
    if (
      submitter &&
      form.contains(submitter) &&
      (submitter.type === 'submit' || submitter.tagName === 'BUTTON')
    ) {
      return submitter;
    }

    const active = document.activeElement;
    if (
      active &&
      form.contains(active) &&
      (active.type === 'submit' || active.tagName === 'BUTTON')
    ) {
      return active;
    }

    return form.querySelector('[type="submit"], button:not([type="button"])');
  };

  const usesFullSubmitLoading = (loadable) =>
    loadable.getAttribute('data-loadable-id') === 'checkout';

  const activateFormLoading = (loadable, submitEvent) => {
    const submitControl = getSubmitControl(submitEvent.target, submitEvent);

    if (loadable.classList.contains('is-loading')) {
      activateButtonLoading(submitControl);
      return;
    }

    if (usesFullSubmitLoading(loadable)) {
      activateLoading(loadable, { scroll: false });
    } else {
      loadable.classList.add('loadable--submit', 'is-loading');
    }

    activateButtonLoading(submitControl);
  };

  const activateLoading = (loadable, { scroll = true } = {}) => {
    const wasLoading = loadable.classList.contains('is-loading');
    loadable.classList.add('is-loading');
    app?.classList.add('is-loading');

    if (wasLoading || !scroll) return;

    // Scroll so that the loadable is at the top of the viewport, accounting for --site-header-height
    const headerHeight =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--site-header-height'
        )
      ) || 0;
    const stepper = document.querySelector('.stepper-row');
    const stepperHeight = stepper ? stepper.offsetHeight : 0;
    const rect = loadable.getBoundingClientRect();
    const absoluteElementTop = rect.top + window.pageYOffset;
    const offsetPosition = absoluteElementTop - headerHeight - stepperHeight;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-loadable-trigger]');
    if (!trigger) return;

    const loadableId = trigger.getAttribute('data-loadable-trigger');
    const loadable = Array.from(loadables).find(
      (loadable) => loadable.getAttribute('data-loadable-id') === loadableId
    );

    if (loadable) {
      activateLoading(loadable, {
        scroll: shouldScrollOnLoad(loadable, trigger),
      });
    }
  });

  const shouldSkipLoadingForLink = (link) => {
    const target = (
      link.getAttribute('target') ||
      link.target ||
      ''
    ).toLowerCase();

    return (
      target === '_blank' ||
      link.hasAttribute('download') ||
      link.hasAttribute('data-no-loadable')
    );
  };

  loadables.forEach(function (loadable) {
    const formCanProceed = (form) =>
      !form.classList.contains('is-validatable') ||
      form.classList.contains('is-valid');

    // handle form submit events
    if (loadable.tagName && loadable.tagName.toLowerCase() === 'form') {
      loadable.addEventListener('submit', (e) => {
        if (!formCanProceed(loadable)) return;

        if (loadable.hasAttribute('data-loadable-no-scroll')) {
          activateLoading(loadable, {
            scroll: shouldScrollOnLoad(loadable, loadable),
          });
          return;
        }

        activateFormLoading(loadable, e);
      });
    }

    // handle internal form submit events
    const forms = loadable.querySelectorAll('form');
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (!formCanProceed(form)) return;

        if (form.hasAttribute('data-loadable-no-scroll')) {
          activateLoading(loadable, {
            scroll: shouldScrollOnLoad(loadable, form),
          });
          return;
        }

        activateFormLoading(loadable, e);
      });
    });

    // handle link clicks
    loadable.addEventListener('click', (e) => {
      const link = e.target.closest('a:not([aria-controls])');
      if (!link || !loadable.contains(link)) {
        return;
      }

      if (!shouldSkipLoadingForLink(link)) {
        activateLoading(loadable, {
          scroll: shouldScrollOnLoad(loadable, link),
        });
      }
    });
  });
});
